<template>
  <div style="width: 100%">
    <div @click="onClick">
      <slot />
    </div>
    <Popup v-model="show" position="bottom" round >
      <datetime-picker
          :max-date="maxDate"
          :min-date="minDate"
          :value="value"
          type="datetime"
          title="选择时间"
          @confirm="onConfirm"
          @cancel="close"
      />
    </Popup>
  </div>
</template>
<script>


import {defineComponent} from "vue";
import {DatetimePicker, Popup} from "vant";

export default defineComponent({
  components: {Popup, DatetimePicker},
  props: {
    value: {
      type: Date,
      required: true
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    onClick() {
      this.open()
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    onConfirm(value) {
      this.$emit("input", value)
      this.close()
    },
  }
})
</script>

<style scoped lang="scss">

</style>
